import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { StageErrorsAggregator } from '@chess/api-insights';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import { registerCard } from '@chess/api-dashboard';
import '@chess/api-insights/charts.css';
import { MIDDLEGAME_BLUNDERS_CARD, MiddlegameBlundersCard } from './MiddlegameBlundersCard.tsx';

// Home dashboard card "Middlegame blunders": reads the middlegame slice of the game store's
// and renders `MiddlegameBlundersCard` in the Middlegame screen's "More"
// section (`middlegame.more`, order 10; moved out of the top cards, which
// Home also shows, on 2026-10-08). Its links open the library
// filtered by `blunder` (`libraryLink`); the library, like the card, covers the last 30 days.
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  // The stage's errors, shared with the other middlegame cards: the service runs it once.
  const aggregator = new StageErrorsAggregator('middlegame');
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <MiddlegameBlundersCard loading />;
    return result ? <MiddlegameBlundersCard middlegame={result} link={link} /> : null;
  };
  registerCard(app, 'middlegame.more', Card, { order: 10, ...MIDDLEGAME_BLUNDERS_CARD });
}
